export default class Orphans {
	static adopt(selector: string) {
		let nodelist = document.querySelectorAll(selector);
		for (let i = 0, l = nodelist.length; i<l; i++){
			nodelist[i].innerHTML = nodelist[i].innerHTML.replace(/\s([^\s]*)$/, '&nbsp;'+'$1');
		}
	}
}
